module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAPCAYAAAA/I0V3AAABNklEQVQ4T4XSv0tWcRTH8ddRUPwRiU4hNDg71KCuiUMt/gVCq2BrQ6u4uoRB5RpGWw4irk4ZiIMZTrVF5ZKQhkV05MAVHuN59AsXLpfzvnw+7+8JLScze3AbS5jEAZ7gU0T8uRiNzOzCEEYxh3F0Yx5PUT/6gDV8wXFB01jAXfzAa+zgO27iHh7iBvbwvKBNbGAby7iFxD9UisBXPMYMHhR02OQ/wyB6W3s2779xgj68K+gjJiLiV5vhS58ysx/vr4QaSSUlI+LvtVBm1vAIFuuJiG9tocwcaHJXh4ryDPtYiYjjTlCZe4W3ZQm7eFn6I6pJm07NRtzBagO+wFEBZaRjpwYcRtn8eQG0g6Zw2jrwv/7MrEuuzjsVdAvreIMS0OnUpdduzhZ0H48w1qxMJ6jW6nOZPAerqaRJ/+NbZQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./assets/images/icon_f4.png
// module id = yKW0
// module chunks = 14 17